<template>
    <div
        :class="{
            'c-header-main__search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <AutocompleteForm
                v-model="keyword"
                :autocomplete-url="autocompleteUrl"
                :is-form-visible="isFormVisible"
                :is-open="isOpen"
                :input-placeholder="inputPlaceholder"
                @show-form="showForm"
                @hide-form="hideForm"
                @searched="setMatches"
            />

            <AutocompleteResults
                v-if="isOpen"
                :matches="matches"
                :keyword="keyword"
                :totals="totals"
            />
        </div>
    </div>
</template>

<script>
import { checkResolution } from "../../../functions/helpers";
import { disableScroll, enableScroll } from "../../../functions/scroll-lock";
import RshopAutocomplete from "../../../../../vendor/rshop/frontend/assets/js/components/Autocomplete";

export default {
    components: {
        AutocompleteForm: () => import("./AutocompleteForm"),
        AutocompleteResults: () => import("./AutocompleteResults"),
    },
    extends: RshopAutocomplete,
    data() {
        return {
            isFormVisible: false,
        };
    },
    computed: {
        inputPlaceholder() {
            return checkResolution("cxs") ? this.$t("Autocomplete.Header.placeholderMobile") : this.$t("Autocomplete.Header.placeholder");
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                if(!checkResolution("cxs")){
                    addOverlay();
                }
                disableScroll();
            } else {
                removeOverlay();
                enableScroll();
            }
        },
    },
    created() {
        if (typeof Event.on === "function") {
            Event.on("Autocomplete.showForm", (response) => {
                if (this.isFormVisible) {
                    this.hideForm();
                } else {
                    this.showForm();
                }
            });
        }
    },
    methods: {
        showForm() {
            this.isFormVisible = true;

            if (this.matches.count) {
                this.isOpen = true;
            }
        },
        hideForm() {
            this.isFormVisible = false;
        },
        handleClickOutside($event) {
            if (
                !this.$el.contains($event.target) &&
                (this.isOpen || this.isFormVisible) &&
                !$event.target.parentNode.classList.contains("js-trigger-search")
            ) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.Event.dispatch === "function") {
                    window.Event.dispatch("Autocomplete.hide");
                }
            }
        },
    },
};
</script>
